// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/timeline/timeline.js#1 $
'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcTimeline
* @element ANY
* @description
* # tcTimeline
* Displays Timeline
*/
angular.module('tcApp')
.directive('tcTimeline', function($window, $document, $log, $mdMedia, $timeout, tcConstants, 
									TimelineService, LegacyScopeService, GlobalService) {
	var timelineLink = function(scope, element, attrs, ctrl) {
		var d3 = $window.window.d3;
		var transitionDuration = TimelineService.getSvgTransitionDuration();
		
		// elements
		var containerElement = element[0].parentElement;
		var timeHeaderSvg = d3.select(element[0]).selectAll('.timelineTimeHeaderSVG');
		var brushG;
		
		var scrollable = null;
		var timelineFieldContainer = null;
		
		/// Functions ///
		// Using container element, gets width for time header portion of timeline controls
		scope.getTimeHeaderWidthFromContainer = function() {
			if (angular.isElement(containerElement)) {
				var containerWidth = containerElement.clientWidth;
				// Use 0.75 when gt-md and 0.6 otherwise to match flex weights
				var widthFactor = ($mdMedia('gt-md') ? 0.75 : 0.6);
				return (scope.viewModel.showLegend ? containerWidth * widthFactor : containerWidth);
			}
			return 960;
		};
		
		// Resize time header SVG element with new dimensions
		var resizeTimeHeaderSvg = function() {
			var svgWidth = scope.viewModel.timeHeaderWidth;
			var svgHeight = scope.viewModel.timeHeaderDimensions.timeHeaderHeight 
				+ scope.viewModel.timeHeaderDimensions.relativeTimeOffset;
			timeHeaderSvg
				.attr('height', svgHeight)
				.attr('width', svgWidth);
				timeHeaderSvg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight);
			timeHeaderSvg.attr('preserveAspectRatio', 'none');

			
			timeHeaderSvg.selectAll('.scrollable').attr('width', scope.viewModel.timeHeaderDimensions.width);
			timeHeaderSvg.selectAll('.timeHeaderClipPathRect').attr('width', scope.viewModel.timeHeaderDimensions.width);
			timeHeaderSvg.selectAll('.timeHeaderContainer').attr('width', scope.viewModel.timeHeaderDimensions.width);
			
			updateAxis(scope.viewModel.JSTimeFrom, scope.viewModel.JSTimeTo);
		};
		
		// call xAxis and restyle ticks
		var callXAxis = function(g) {
			g.call(scope.viewModel.xAxis);
			g.selectAll('.tick text').attr('y', 2);
			g.selectAll('.tick line').attr('stroke', '');
			g.selectAll('.domain').attr('stroke', '');
		};
	
		// Call xAxis for super headings. adding background rect if necessary
		var callSuperHeadingXAxis = function(g, useTransition) {
			g.call(scope.viewModel.superHeadingXAxis);
			g.selectAll('.tick text').attr('y', 0).attr('class', 'graphLabelText');
			g.selectAll('.tick line').attr('stroke', '');
			g.selectAll('.domain').attr('stroke', '');
		
			var drawTickBackgroundRect = function() {
				// when called from timeout, transition may have already expired,
				// so convert back into a normal selection to avoid error
				if (angular.isFunction(g.selection)) g = g.selection();
				
				var rects = {};
				
				g.selectAll('.tick').each(function() {
					// add background rect behind text to overlap left anchored super heading
					var elementSelection = d3.select(this);
					var rect = elementSelection.select('rect');
					if (rect.empty()) rect = elementSelection.insert('rect', 'text').attr('class', 'superHeadingLabelRect');
					var text = elementSelection.select('text');
					var bbox = text.node().getBBox();
					// if sticky header is hidden, bbox has 0 height/width,
					// so store bboxes from normal header and use them instead
					if ((bbox.height !== 0) && (bbox.width !== 0)) {
						rects[text.text()] = bbox;
					} else if (angular.isDefined(rects[text.text()])) {
						bbox = rects[text.text()];
					}
					rect.attr('x', bbox.width / -2)
						.attr('y', -11)
						.attr('height', bbox.height)
						.attr('width', bbox.width)
						.style('fill', 'white');
				});
			};

			if (useTransition) {
				// wait until transition has completed
				// so any new ticks will still get backgrounds
				$timeout(drawTickBackgroundRect);
			} else {
				drawTickBackgroundRect();
			}
		};
		
		// Call xAxis for relative Time Markers.
		var callRelativeMarkersXAxis = function(g, useTransition) {
			if (angular.isFunction(scope.viewModel.relativeMarkersXAxis)) {
				g.call(scope.viewModel.relativeMarkersXAxis);
				g.selectAll('.domain').attr('stroke', '');
				g.selectAll('.tick text').attr('y', scope.viewModel.timeHeaderDimensions.relativeTimeOffset - 3);
				g.selectAll('.tick line').attr('class', 'relativeTimeLine');
				
				var drawRelativeMarkerContainers = function() {
					// when called from timeout, transition may have already expired,
					// so convert back into a normal selection to avoid error
					if (angular.isFunction(g.selection)) g = g.selection();
					
					var selection = g.selectAll('.tick');
					var rectWidths = {};
					selection.each(function(d, index) {
						var elementSelection = d3.select(this);
						var rect = elementSelection.select('rect');
						if (rect.empty()) rect = elementSelection.insert('rect', 'line').attr('class', 'relativeTimeRect');
						var text = elementSelection.select('text');
						var bbox = text.node().getBBox();
						if (bbox.width > 0) { // store widths to be used by hidden clone elements
							rectWidths[index] = bbox.width + 5;
						}
						// add rect to contain relative marker text
						rect.attr('x', 0)
							.attr('y', 0)
							.attr('height', scope.viewModel.timeHeaderDimensions.relativeTimeOffset)
							.attr('width', function() {
								if (angular.isNumber(rectWidths[index])) {
									return rectWidths[index];
								}
							});
						
						// center text within rect
						if (angular.isNumber(rectWidths[index])) {
							text.attr('x', (rectWidths[index] / 2));
						}
					});
				};
				
				if (useTransition) {
					// wait until transition has completed
					// so any new ticks will still get containers
					$timeout(drawRelativeMarkerContainers);
				} else {
					drawRelativeMarkerContainers();
				}
			}
		};
		
		var legacyFunctions = LegacyScopeService.getLegacyFunctions(scope);
	
		var dateObjectToDateString = legacyFunctions.DateObjectToDateString;
	
		var reWriteTime = legacyFunctions.ReWriteTime;
	
		var websysFetch = legacyFunctions.websys_fetch;
	
		// Draws the time cursor and labels it with the selected time
		var drawTimeCursorAndLabel = function(selectedTime, useTransition, updateElement) {
			// If no time is selected, or the time is outside the visible window, hide the cursor group
			var timeCursorGroup = updateElement.selectAll('g.timeCursorGroup');
			
			if (angular.isUndefined(selectedTime)) {
				timeCursorGroup
					.attr('opacity', 0);
				return;
			}
			
			var selectedTimeJSTime = selectedTime.getTime();
			
			if ((selectedTimeJSTime < scope.viewModel.JSTimeFrom) || (selectedTimeJSTime > scope.viewModel.JSTimeTo)) {
				timeCursorGroup
					.attr('opacity', 0);
				return;
			}
			
			// Update cursor label and position	
			var selectedPosition = ctrl.getXCoordinateFromTime(selectedTime);
			
			timeCursorGroup
				.attr('transform', 'translate(' + selectedPosition + ',0)')
				.attr('opacity', 1);
			
			var timeCursorTextLabel = timeCursorGroup.selectAll('text');
			var newDateString = dateObjectToDateString(selectedTime);
			var newTimeString = reWriteTime(selectedTime.getHours(), selectedTime.getMinutes(), selectedTime.getSeconds());
			timeCursorTextLabel
				.text(newDateString + ' ' + scope.tcTranslations['XAT'] + ' ' + newTimeString);
			
			var timeCursorTextWidth = timeCursorTextLabel.node().getBBox().width;
			timeCursorGroup.selectAll('.timeCursorLabelRect')
				.attr('x', -timeCursorTextWidth / 2 - 2)
				.attr('width', timeCursorTextWidth + 20);

			timeCursorGroup.selectAll('.timeCursorClose')
				.attr('x', timeCursorTextWidth / 2 + 2);
		};
		
		// Apply style overrides to brush selection
		scope.restyleBrushSelection = function() {
			if (angular.isDefined(brushG)) {
				brushG.selectAll('.selection')
					.attr('height', (scope.viewModel.brushDimensions.height - 2))
					.attr('y', 1)
					.attr('rx', 1)
					.attr('ry', 1)
					.attr('tabindex', 0);
			}		
		};
		
		// set the visible timeFrom/To of the timeline
		var updateAxis = function(timeFrom, timeTo) {
			// Move brush to reflect new timeFrom/To
			scope.viewModel.brush.move(brushG, [timeFrom, timeTo].map(scope.viewModel.brushScale));
			
			// Recalculate X axis domain (zoom into provided times)
			ctrl.updateTimeWindow(timeFrom, timeTo);
			
			// Prepare SVG transition or use plain svg element
			var useTransition = (scope.viewModel.lastInterval !== scope.data.interval.value);
			var updateElement = (useTransition ? timeHeaderSvg.transition().duration(transitionDuration) 
								: timeHeaderSvg);
			scope.viewModel.lastInterval = scope.data.interval.value;
			
			// Move X axis
			updateElement.selectAll('g.x.axis')
				.call(callXAxis);
			
			// Move X axis super headings
			updateElement.selectAll('g.x.superHeadingAxis')
				.call(callSuperHeadingXAxis, useTransition);
		
			// update Major axis caption
			updateElement.selectAll('text.majorAxisLabel')
				.text(TimelineService.formatSuperHeadingTick(scope.viewModel.JSTimeFrom, scope.data.interval.value, true));

			// update relative Time markers
			if (angular.isFunction(scope.viewModel.relativeMarkersXAxis)) {
				// in IOS, using transition causes performance issue, so use timeHeaderSvg in all cases
				var userAgent = $window.navigator.userAgent || $window.navigator.vendor || $window.opera;
				var isIos = userAgent.match(/ipad|iphone|ipod/i);
				var relativeMarkersUpdateElement = (isIos ? timeHeaderSvg : updateElement);
				var relativeMarkersUseTransition = (isIos ? false : useTransition);
				relativeMarkersUpdateElement.selectAll('g.x.relativeTimeMarkersAxis')
					.call(callRelativeMarkersXAxis, relativeMarkersUseTransition);
			}
			
			// Update timeNow label and shaded area
			var timeNow = scope.data.JSTimeNow;
			var timeNowCoordinate = ctrl.getXCoordinateFromTime(timeNow);
			var timeNowGroup = updateElement.selectAll('g.timeNowGroup');
			timeNowGroup.attr('transform', 'translate(' + timeNowCoordinate + ',0)');
			var futureTimeRect = timeNowGroup.selectAll('rect.timeNow');
			var timeNowLabel = timeNowGroup.selectAll('g.timeNowLabelGroup');
			if (timeNow > scope.viewModel.JSTimeTo) { // entire window is in the past, hide everything
				timeNowGroup.attr('opacity', 0);
			} else if (timeNow < scope.viewModel.JSTimeFrom) { // entire window is in the future, only show shading rect
				timeNowGroup.attr('transform', 'translate(0,0)');
				timeNowLabel.attr('opacity', 0);
				futureTimeRect.attr('width', scope.viewModel.timeHeaderDimensions.width);
			} else { // timeNow marker is within visible window, update position of label and rect
				timeNowGroup.attr('opacity', 1)
					.attr('transform', 'translate(' + timeNowCoordinate + ',0)');
				timeNowLabel.attr('opacity', 1);
				var timeNowDiff = scope.viewModel.timeHeaderDimensions.width - timeNowCoordinate;
				var rectWidth = (timeNowDiff >= 0 ? timeNowDiff : 0);
				futureTimeRect.attr('width', rectWidth);
			}
			
			// Update timeDob label and line
			if (scope.data && scope.data.useGestation) {
				var timeDobCoordinate = ctrl.getXCoordinateFromTime(scope.data.dobJSTime);
				var timeDobGroup = updateElement.selectAll('g.timeDobGroup');
				timeDobGroup.attr('transform', 'translate(' + timeDobCoordinate + ',0)');
			}
			
			drawTimeCursorAndLabel(scope.viewModel.selectedTime, useTransition, updateElement);
		};
		
		var resizeWhenStable = function() {
			// wait until parent container is stable before handling resize
			angular.getTestability(containerElement).whenStable(scope.handleResize);
		};
		
		// For component based timelines (currently Administration and Observation Timelines)
		// Aligns their time columns with the rest of the timeline grid
		var scrollContainers = function() {
			var scrollDivs = element[0].querySelectorAll('.clinicalProfileItem');
			if (scrollDivs.length === 0) return;
		
			var ComponentTimelineDateFrom = new Date(scope.viewModel.brushDomainStartTime);
			ComponentTimelineDateFrom.setHours(0, 0, 0, 0);

			var intervalCode = scope.data.interval.value;
			var intervalInMS = scope.data.interval.JSTime;

			var timeLapsed = 0;
			var intervalsLapsed = 0;

			if (intervalCode == TimelineService.IntervalMonth) {
				// Component based timelines do not have partial columns
				// For month interval, correct the starting date of the first time column; set it to the first day of the month
				ComponentTimelineDateFrom.setDate(1); 

				// Find time coordinate of the current visible column
				var columnStartTime = new Date(scope.viewModel.JSTimeFrom);
				columnStartTime.setHours(0, 0, 0, 0);
				columnStartTime.setDate(1);
			
				// Find number of whole months that have elapsed
				intervalsLapsed = d3.timeMonth.count(ComponentTimelineDateFrom, columnStartTime);
				// Add fractional value
				intervalsLapsed += (scope.viewModel.JSTimeFrom - columnStartTime.getTime()) / intervalInMS;
			} else if (intervalCode == TimelineService.IntervalWeek) {
				// For week interval, correct the starting date of the first time column; set it to the first day of the week
				var weekDay = ComponentTimelineDateFrom.getDay();
				var adjust = (weekDay + 6) % 7;
				var newDay = ComponentTimelineDateFrom.getDate() - adjust;
				ComponentTimelineDateFrom.setDate(newDay);
					
				timeLapsed = scope.viewModel.JSTimeFrom - ComponentTimelineDateFrom.getTime();
				intervalsLapsed = timeLapsed / intervalInMS;
			} else if ((intervalCode == TimelineService.Interval24H) || (intervalCode == TimelineService.IntervalYear)) {
				timeLapsed = scope.viewModel.JSTimeFrom - ComponentTimelineDateFrom.getTime();
				intervalsLapsed = timeLapsed / intervalInMS;
			} else {
				var queryStartTime = scope.viewModel.brushDomainStartTime;
				var timeOfDate = queryStartTime - ComponentTimelineDateFrom.getTime();			
				queryStartTime = queryStartTime - (timeOfDate % intervalInMS);

				intervalsLapsed = (scope.data.JSTimeFrom - queryStartTime) / intervalInMS;
			}
			for (var i = 0; i < scrollDivs.length; i++) {
				scrollDivs[i].scrollLeft = ((scope.viewModel.columnWidth + 1) * intervalsLapsed);
			}
		};
		
		var recalculateColumnWidths = function() {
			var scrollDivs = element[0].querySelectorAll('.clinicalProfileItem');
			for (var i = 0; i < scrollDivs.length; i++) {
				var currentCol = 0;
				var table = scrollDivs[i].querySelector('table');
				if (!table) continue; // Case when clinical profile doesn't have data
				var isObs = false;
				if ((table.id != '')&&(table.id.includes('MRObservations'))) {
					isObs = true;
				}
				var existingColGroup = table.querySelector('colgroup');
				if (existingColGroup) existingColGroup.remove();
				var colGroup = '<colGroup>';
				var row = table.querySelector('tr.componentTableRow');
				if (!row) continue; // Case when clinical profile doesn't have data
				var cols = row.querySelectorAll('td');
				var lineColumnWidth;
				var svgLegendWidth = 80;
				var checkBoxWidth = 40;
				if (scope.getLegendContainerClass() == 'flex-25') {
					// Legend to graph ratio is 1:3 (25:75)
					lineColumnWidth = Math.round(scope.viewModel.timeHeaderWidth / 3 + svgLegendWidth);
				} else {
					// Legend to graph ratio is 4:6 (40:60)
					lineColumnWidth = Math.round(scope.viewModel.timeHeaderWidth * 4 / 6 + svgLegendWidth);
				}
				lineColumnWidth = lineColumnWidth - checkBoxWidth - svgLegendWidth;
				var currentLeftOffset = 0;
				// Row selector checkboxes
				if (cols[0].classList.contains('componentTableRowSelect')) {
					colGroup += '<col style="width: ' + (checkBoxWidth - 1) + 'px;">';
					currentLeftOffset += checkBoxWidth - 1;
					currentCol += 1;
				} else {
					// No checkboxes -- make second column larger
					svgLegendWidth = svgLegendWidth + checkBoxWidth;
				}
				// Add styles for order line column
				currentCol += 1;
				
				// handling hidden Obs profile simple add column
				if (cols[currentCol].classList.contains('ng-hide')) {
					// simple add is off, observation description takes all spaces
					lineColumnWidth = lineColumnWidth + svgLegendWidth;
				} else if (isObs) {
					// add more spaces for simple add column
					lineColumnWidth = lineColumnWidth - 20;
					svgLegendWidth = svgLegendWidth + 20;
				}
				
				colGroup += '<col style="width:' + (lineColumnWidth) + 'px;">';
				angular.forEach(table.querySelectorAll('tr.componentTableRow td:nth-child(' + currentCol + ')'), function(item) {
					item.style = 'left:' + currentLeftOffset + 'px;';
				});
				currentLeftOffset += lineColumnWidth;

				// handling hidden Obs profile simple add column
				if (cols[currentCol].classList.contains('ng-hide')) {
					currentCol += 1;
				} else {
					// Add styles for icon profile column or Obs simple add column.
					currentCol += 1;
					colGroup += '<col style="width: ' + (svgLegendWidth - 1) + 'px;">';
				}
				angular.forEach(table.querySelectorAll('tr.componentTableRow td:nth-child(' + currentCol + ')'), function(item) {
					item.style = 'left:' + currentLeftOffset + 'px;';
				});

				if (isObs) {
					// Set the position for Obs simple add column header.
					var header = table.querySelector('thead th:nth-child(' + currentCol + ')');
					if (header) header.style = 'left:' + currentLeftOffset + 'px;';
				}

				// Adjust group headers to be non-scrollable
				angular.forEach(table.querySelectorAll('td.componentTableRowGroupToggle div'), function(item) {
					item.style = 'left:' + checkBoxWidth + 'px;';
				});

				// Browser can only display integer column widths; so we need to have variable column widths in the table
				// to approximate for fractional columnWidth in the graph
				var colIndex;
				var currentColWidth;
				var totalWidth = 0;
				var graphCol = 0;
				var TimeslotWidth = (scope.viewModel.columnWidth + 1);
				for (colIndex = currentCol; colIndex < cols.length - 1; colIndex++) {
					graphCol++;
					currentColWidth = Math.round(TimeslotWidth * graphCol) - totalWidth;
					totalWidth += currentColWidth;
					colGroup += '<col style="width:' + currentColWidth + 'px;">';
				}
				
				// Planned lines need to be adjusted as they are all offset from the first timeslot
				// Please make sure any changes to column width logic are accounted for here
				var PlannedLines = table.querySelectorAll('.IVPlanned');
				var LineOffset = 0;
				var LineWidth = 0;
				for (var lineIndex = 0; lineIndex < PlannedLines.length; lineIndex++) {
					LineOffset = Math.round(TimeslotWidth * PlannedLines[lineIndex].dataset.toffset);
					LineWidth  = Math.round(TimeslotWidth * PlannedLines[lineIndex].dataset.tspanned);
					
					PlannedLines[lineIndex].style.left = LineOffset + 'px';
					PlannedLines[lineIndex].style.width = LineWidth + 'px';
				}
				
				// style "action" column
				colGroup += '<col style="width:70px;" class="actions-cell">';
				colGroup += '</colGroup>';
				angular.element(table).prepend(colGroup);
			}
			scrollContainers();
		};

		var handleScroll = function() {
			var scrollTop = scrollable[0].scrollTop;
			// Sometimes the offset is wrong because of content still loading
			// This will keep triggering and ensures the scroll is set to exactly the correct value
			if (!scope.data.initScroll) {
				// initScrollCount is a failsafe to prevent the scroll from being locked
				// the vertical size of the timeline can be changed by collapsing and would break the scroll logic
				scope.viewModel.initScrollCount = scope.viewModel.initScrollCount + 1;
				if ((scrollTop === scope.data.cachedScrollY) || (scope.viewModel.initScrollCount > 3)) {
					scope.data.initScroll = true;
				} else {
					// setting scroll here triggers the handleScroll function again, so quit out
					scrollable[0].scrollTop = scope.data.cachedScrollY;
				}
				return;
			}

			if (scrollable[0].scrollHeight > scrollable[0].clientHeight) {
				// only save scroll if timeline is scrollable
				// this is to prevent it from saving when clicking away to another work area function
				scope.data.cachedScrollY = scrollTop;
			}

			ctrl.passCacheValues();

			var containerTop = ctrl.getOffsetTop(scrollable[0]);
			// get the height of timeline header
			var timelineHeader = scrollable[0].querySelector('.timelineHeader');
			var fixedHeaderHeight = timelineHeader.clientHeight;
			
			var scrollDivs = element[0].querySelectorAll('.clinicalProfileItem');
			for (var i = 0; i < scrollDivs.length; i++) {
				var table = scrollDivs[i].querySelector('.clsMRObservations_List table');
				if (!table) continue;
				var tableTop = ctrl.getOffsetTop(table);
				var tableBottom = tableTop + table.offsetHeight;
				var thead = scrollDivs[i].querySelector('.clsMRObservations_List thead');
				if (!thead) continue;
				var theadOffsetTop = tableTop - containerTop;
				thead = angular.element(thead);
				var scrollY = scrollTop + fixedHeaderHeight;
				if ((scrollY > theadOffsetTop) && (scrollY < (tableBottom - containerTop))) {
					thead.addClass('sticky-visible');
					thead.css({
						'top': (scrollTop + fixedHeaderHeight - theadOffsetTop - 1) + 'px',
					});
				} else {
					thead.removeClass('sticky-visible');
					thead.css({'top': ''});
				}
			}
		};
		
		/// Initalize all SVG elements ///
		// Add time control svg elements
		var svg = d3.select(element[0]).selectAll('.timeControlBrush').append('svg')
			.attr('width', scope.viewModel.brushDimensions.width + scope.viewModel.brushDimensions.margin * 2)
			.attr('height', scope.viewModel.brushDimensions.height + scope.viewModel.brushDimensions.marginTop)
			.append('g')
				.attr('transform', 'translate(' 
					+ scope.viewModel.brushDimensions.margin + ',' 
					+ (scope.viewModel.brushDimensions.marginTop) + ')')
				.call(scope.viewModel.brushScale);

		brushG = svg.append('g')
			.attr('class', 'brush')
			.call(scope.viewModel.brush);
		
		// Add borders to slider
		brushG.append('line')
			.attr('x1', -1)
			.attr('y1', 0)
			.attr('x2', -1)
			.attr('y2', scope.viewModel.brushDimensions.height)
			.attr('stroke', 'black');
		
		brushG.append('line')
			.attr('x1', scope.viewModel.brushDimensions.width + 1)
			.attr('y1', 0)
			.attr('x2', scope.viewModel.brushDimensions.width + 1)
			.attr('y2', scope.viewModel.brushDimensions.height)
			.attr('stroke', 'black');
	
		// Setup timeHeader svg
		ctrl.setTimeHeaderDimensions();
		
		var container = timeHeaderSvg.append('g')
					.attr('transform', 'translate(' + scope.viewModel.timeHeaderDimensions.margin.left + ',0)');
		
		// add major axis text before timeHeader clip path so header elements will cover it on scroll
		container.append('text')
			.attr('class', 'majorAxisLabel graphLabelText')
			.attr('y', scope.viewModel.timeHeaderDimensions.superHeadingOffset);
		
		container.append('clipPath')
			.attr('id', 'timeHeaderClipPath')
			.append('rect')
				.attr('class', 'timeHeaderClipPathRect')
				.attr('x', 0)
				.attr('y', 0)
				//.attr('width', scope.viewModel.timeHeaderDimensions.width)
				.attr('height', scope.viewModel.timeHeaderDimensions.timeHeaderHeight 
					+ scope.viewModel.timeHeaderDimensions.relativeTimeOffset);
		
		var timeHeaderClipPath = container.append('g')
			.attr('clip-path', 'url(#timeHeaderClipPath)');
	
		// timeHeaderContainer will hold all x axis svg elements
		var timeHeaderContainer = timeHeaderClipPath.append('g')
			//.attr('width', scope.viewModel.timeHeaderDimensions.width)
			.attr('class', 'scrollable');
		
		timeHeaderContainer.append('g')
			.attr('transform', 'translate(0,0)');
		
		timeHeaderContainer.append('g')
			.attr('class', 'x axis')
			.attr('font-size', '')
			.attr('transform', 'translate(0,' + (scope.viewModel.timeHeaderDimensions.timeHeaderHeight
				+ scope.viewModel.timeHeaderDimensions.axisOffset) + ')')
			.call(callXAxis);
		
		timeHeaderContainer.append('g')
			.attr('class', 'x superHeadingAxis')
			.attr('font-size', '')
			.attr('transform', 'translate(0,' + scope.viewModel.timeHeaderDimensions.superHeadingOffset + ')')
			.call(callSuperHeadingXAxis);
		
		timeHeaderContainer.append('g')
			.attr('class', 'x relativeTimeMarkersAxis')
			.attr('font-size', '')
			.attr('transform', 'translate(0,0)')
			.call(callRelativeMarkersXAxis);
			
		// Add svg elements for timeNow label and line
		var timeNowGroup = container.append('g')
			.attr('class', 'timeNowGroup');
		
		timeNowGroup.append('rect')
			.attr('class', 'timeNow')
			.attr('x', 0)
			.attr('y', scope.viewModel.timeHeaderDimensions.relativeTimeOffset)
			.attr('height', scope.viewModel.timeHeaderDimensions.timeHeaderHeight);
		
		var timeNowlabelGroup = timeNowGroup.append('g')
			.attr('class', 'timeNowLabelGroup');
		
		timeNowlabelGroup.append('line')
			.attr('class', 'timeNowLine')
			.attr('x1', 0)
			.attr('y1', scope.viewModel.timeHeaderDimensions.relativeTimeOffset)
			.attr('x2', 0)
			.attr('y2', scope.viewModel.timeHeaderDimensions.timeHeaderHeight
				+ scope.viewModel.timeHeaderDimensions.relativeTimeOffset);
		
		var timeNowTextSelection = timeNowlabelGroup.append('text')
			.attr('class', 'timeNowText graphLabelText')
			.attr('y', scope.viewModel.timeHeaderDimensions.relativeTimeOffset - 2)
			.attr('text-anchor', 'middle')
			.text(TimelineService.getNowCaption());
		
		// add white background rect to overlay Now text over relative Time markers
		var timeNowTextWidth = timeNowTextSelection.node().getBBox().width;
		timeNowlabelGroup.insert('rect', 'text')
			.attr('class', 'timeNowLabelRect')
			.attr('x', -timeNowTextWidth / 2)
			.attr('y', scope.viewModel.timeHeaderDimensions.relativeTimeOffset
				- scope.viewModel.timeHeaderDimensions.timeNowHeight)
			.attr('width', timeNowTextWidth)
			.attr('height', scope.viewModel.timeHeaderDimensions.timeNowHeight - 1);
		
		// Add svg elements for timeDob label and line if we are in gestation offset mode
		if (scope.data && scope.data.useGestation) {
			var timeDobGroup = container.append('g')
				.attr('class', 'timeDobGroup');
			
			timeDobGroup.append('line')
				.attr('class', 'relativeTimeLine')
				.attr('x1', 0)
				.attr('y1', scope.viewModel.timeHeaderDimensions.relativeTimeOffset)
				.attr('x2', 0)
				.attr('y2', scope.viewModel.timeHeaderDimensions.timeHeaderHeight
					+ scope.viewModel.timeHeaderDimensions.relativeTimeOffset);
			
			var timeDobTextSelection = timeDobGroup.append('text')
				.attr('class', 'timeNowText graphLabelText')
				.attr('y', scope.viewModel.timeHeaderDimensions.relativeTimeOffset
					+ scope.viewModel.timeHeaderDimensions.timeNowHeight)
				.attr('text-anchor', 'middle')
				.text(TimelineService.formatRelativeTimeMarker(scope.data.dobJSTime, '', scope.data.dobJSTime));
			
			// add white background rect to overlay DOB text over relative Time markers
			var timeDobTextWidth = timeDobTextSelection.node().getBBox().width;
			timeDobGroup.insert('rect', 'text')
				.attr('class', 'timeNowLabelRect')
				.attr('x', -timeDobTextWidth / 2)
				.attr('y', scope.viewModel.timeHeaderDimensions.relativeTimeOffset)
				.attr('width', timeDobTextWidth)
				.attr('height', scope.viewModel.timeHeaderDimensions.timeNowHeight + 5);
		}
		
		// Add svg elements for timeCursor label and line
		var timeCursorGroup = container.append('g')
			.attr('class', 'timeCursorGroup');
			
		var timeCursorLabelGroup = timeCursorGroup.append('g')
			.attr('class', 'timeCursorLabelGroup');
		
		timeCursorLabelGroup.append('line')
			.attr('class', 'timeCursorLine')
			.attr('y1', scope.viewModel.timeHeaderDimensions.relativeTimeOffset)
			.attr('y2', scope.viewModel.timeHeaderDimensions.timeHeaderHeight
				+ scope.viewModel.timeHeaderDimensions.relativeTimeOffset);
		
		var timeCursorTextSelection = timeCursorLabelGroup.append('text')
			.attr('class', 'timeCursorText')
			.attr('x', 0)
			.attr('y', scope.viewModel.timeHeaderDimensions.relativeTimeOffset - 2)
			.attr('text-anchor', 'middle');
		
		// add yellow background rect to overlay Cursor text over relative Time markers
		var timeCursorTextWidth = timeCursorTextSelection.node().getBBox().width;
		timeCursorLabelGroup.insert('rect', 'text')
			.attr('class', 'timeCursorLabelRect')
			.attr('x', -timeCursorTextWidth / 2)
			.attr('y', scope.viewModel.timeHeaderDimensions.relativeTimeOffset
				- scope.viewModel.timeHeaderDimensions.timeNowHeight - 3)
			.attr('width', timeCursorTextWidth + 2)
			.attr('height', scope.viewModel.timeHeaderDimensions.timeNowHeight + 2);
		
		timeCursorLabelGroup.insert('image')
			.attr('class', 'timeCursorClose')
			.attr('href', '../images/webemr/cross.gif')
			.attr('x', timeCursorTextWidth / 2 + 2)
			.attr('y', scope.viewModel.timeHeaderDimensions.relativeTimeOffset
				- scope.viewModel.timeHeaderDimensions.timeNowHeight - 2)
			.attr('width', scope.viewModel.timeHeaderDimensions.timeNowHeight + 3)
			.attr('height', scope.viewModel.timeHeaderDimensions.timeNowHeight + 3)
			.on('click', function() {
				ctrl.cursorCloseClick();
			});
		
		var notchSize = 8;
		var	notchPoints = '0,0 ' + notchSize * 2 + ',0 ' + notchSize + ',' + notchSize;
		
		timeCursorLabelGroup.insert('polygon')
			.attr('class', 'timeCursorLabelNotch')
			.attr('points', notchPoints) // '0,0 16,0 8,8'
			.attr('transform', 'translate(' + -notchSize + ',' + scope.viewModel.timeHeaderDimensions.timeNowHeight + ')');
						
		// add visual border for time headers and make the area inside clickable to select a time
		container.append('rect')
			.attr('class', 'timeHeaderContainer')
			.attr('x', 0)
			.attr('y', scope.viewModel.timeHeaderDimensions.relativeTimeOffset)
			//.attr('width', scope.viewModel.timeHeaderDimensions.width + 1)
			.attr('height', scope.viewModel.timeHeaderDimensions.timeHeaderHeight)
			.on('click', function() {
				ctrl.headerClick(this);
			});	
		
		resizeTimeHeaderSvg();
		
		// After svg is rendered, move brush to starting position, then add listeners
		ctrl.setBrushValues(scope.viewModel.JSTimeFrom, scope.viewModel.JSTimeTo);
		scope.viewModel.brush.on('start', ctrl.onBrushStart);
		scope.viewModel.brush.on('brush end', ctrl.onBrush);
		scope.restyleBrushSelection();
		
		// setup keyboard listeners for brush
		d3.select('.selection')
			.on('keydown', function() {
				var keyCode = d3.event.keyCode;
				if ((keyCode === tcConstants.KEY_CODE.LEFT_ARROW) || (keyCode === tcConstants.KEY_CODE.RIGHT_ARROW)) {
					var sliderRange = scope.viewModel.brushDomainEndTime - scope.viewModel.brushDomainStartTime;
					// set increment to be +/- one hundreth of the slider range based on arrow key direction
					var increment = (keyCode === tcConstants.KEY_CODE.RIGHT_ARROW ? (sliderRange / 100) : (-sliderRange / 100));
					var newTimeFrom = scope.viewModel.JSTimeFrom + increment;
					var newTimeTo = scope.viewModel.JSTimeTo + increment;
					// If new times are not within range, update values to move to right/left end of brush selection
					if (newTimeTo > scope.viewModel.brushDomainEndTime) {
						newTimeFrom = scope.viewModel.JSTimeFrom + (scope.viewModel.brushDomainEndTime - scope.viewModel.JSTimeTo);
						newTimeTo = scope.viewModel.brushDomainEndTime;
					}
					if (newTimeFrom < scope.viewModel.brushDomainStartTime) {
						newTimeFrom = scope.viewModel.brushDomainStartTime;
						newTimeTo = scope.viewModel.JSTimeTo - (scope.viewModel.JSTimeFrom - scope.viewModel.brushDomainStartTime);
					}
					
					if ((newTimeFrom >= scope.viewModel.brushDomainStartTime) && (newTimeTo <= scope.viewModel.brushDomainEndTime)) {
						ctrl.setBrushValues(newTimeFrom, newTimeTo);
						scope.$digest();
					}
				}
			});
		
		scope.$watch('viewModel.selectedTime', function(newValue, oldValue) {
			if (newValue !== oldValue) {
				drawTimeCursorAndLabel(newValue, false, timeHeaderSvg);
			}
		});
		
		scope.$watch('viewModel.showLegend', function(newValue, oldValue) {
			if (newValue !== oldValue) {
				ctrl.setTimeHeaderDimensions();
			}
		});
		
		scope.$watch('viewModel.timeHeaderWidth', function(newValue, oldValue) {
			if (newValue !== oldValue) {
				resizeTimeHeaderSvg(); // Resize orignal timeline header
				scope.$broadcast('StickyHeader:ReClone'); // Resize the sticky timeline header (clone)
			}
		});
		scope.$watch('data.timeInterval', function(newValue, oldValue) {
			if (newValue !== oldValue) {
				// Timeline data has been reloaded (ex: system.Timeline is AlwaysReload)
				// Need to initialise the system.Timeline.Interval component
				scope.$broadcast('Component:initialise', scope.data.timeInterval.componentParamPrefix, {
						componentName: scope.data.timeInterval.componentName,
						data: scope.data.timeInterval
					});
				
			}
		});
		scope.$watchGroup(['viewModel.brushDomainStartTime', 'viewModel.brushDomainEndTime'], function(newValues, oldValues) {
			if ((newValues[0] !== oldValues[0]) || (newValues[1] !== oldValues[1])) {
				var domainTimeFrom = newValues[0];
				var domainTimeTo = newValues[1];
				var timeFrom = scope.viewModel.JSTimeFrom;
				var timeTo = scope.viewModel.JSTimeTo;
				var interval = scope.data.interval;
				
				ctrl.showNewTimeWindow(timeFrom, timeTo, domainTimeFrom, domainTimeTo, interval);
				
				// update data so that component data reflects new values
				ctrl.updateDataJSQueryTimes();
			}
		});
		
		scope.$watchGroup(['viewModel.JSTimeFrom', 'viewModel.JSTimeTo'], function(newValues, oldValues) {
			if ((newValues[0] !== oldValues[0]) || (newValues[1] !== oldValues[1])) {
				// update data so that component data reflects new values
				ctrl.updateDataJSTimes();
			}
		});
		
		scope.$watchGroup(['viewModel.ItemTimeFrom', 'viewModel.ItemTimeTo'], function(newValues, oldValues) {
			if ((newValues[0] !== oldValues[0]) || (newValues[1] !== oldValues[1])) {
				updateAxis(newValues[0], newValues[1]);
				
				// scroll component containers with brush
				scrollContainers();
			}
		});
		
		scope.$watch('viewModel.columnWidth', function(newValue, oldValue) {
			if (newValue !== oldValue) {
				recalculateColumnWidths();
			}
		});
		
		scope.$watchGroup(['data.JSTimeFrom', 'data.JSTimeTo',
							'data.JSQueryTimeFrom', 'data.JSQueryTimeTo'], function(newValues, oldValues) {
			if (((newValues[0] !== oldValues[0]) && (newValues[0] !== scope.viewModel.JSTimeFrom))
				|| ((newValues[1] !== oldValues[1]) && (newValues[1] !== scope.viewModel.JSTimeTo))
				|| ((newValues[2] !== oldValues[2]) && (newValues[2] !== scope.viewModel.brushDomainStartTime))
				|| ((newValues[3] !== oldValues[3]) && (newValues[3] !== scope.viewModel.brushDomainEndTime))) {
				// update lastInterval to prevent zoom animation and
				// unnecessary data fetches in component timelines on reload
				scope.viewModel.lastInterval = scope.data.interval.value;
				
				ctrl.updateViewModelFromData();
			}
		});

		angular.forEach(scope.data.items, function(item, itemIndex) {
			var watchExpr = 'data.items[' + itemIndex + '].collapsed';
			scope.$watch(watchExpr, function(newValue, oldValue) {
				if ((newValue !== oldValue) && !newValue) {
					$timeout(scrollContainers);
				}
			});
		});
		
		// redraw on document ready to avoid rendering issues on route reload
		$document.ready(function() {
			ctrl.setTimeHeaderDimensions();
			scrollable = GlobalService.getScrollableParent(element[0]);
			scrollable = angular.element(scrollable);
			scrollable.on('scroll', handleScroll);
			// Set cached scroll value - this triggers handleScroll
			scrollable[0].scrollTop = scope.data.cachedScrollY;
			if (scope.data.cachedScrollY === 0) {
				scope.data.initScroll = true;
			}
			scope.viewModel.initScrollCount = 0;

			timelineFieldContainer = scrollable[0].querySelector('.componentFieldContainer');
			timelineFieldContainer = angular.element(timelineFieldContainer);

			scope.$digest();
		});

		scope.$on('$includeContentLoaded', function() {
			$timeout(recalculateColumnWidths);
		});

		angular.element($window).on('resize', scope.handleResize);
		scope.$on('Chart:toggleMenu', resizeWhenStable);
	
		scope.$on('Global:callFunction', function(event, componentHtmlName, 
			functionName, args, callbackFunction) {
			if (componentHtmlName !== 'Timeline') return;
		
			if (angular.isFunction(scope[functionName])) {
				var returnValue = scope[functionName].apply(this, args);
				if (angular.isFunction(callbackFunction)) callbackFunction(returnValue);
			} else {
				$log.warn('Could not find function ', functionName, ' in ', componentHtmlName, ' controller');
			}
		});

		var cacheTimeline = function(unload) {
			var cacheData = scope.getCacheValues();
			var options = {
				methodName: 'CacheTimelineState',
				args: angular.toJson(cacheData),
				className: 'websys.JS.system.Timeline'};
			if (unload === 1) options.eventType ='beforeunload';
			websysFetch(options);
		};

		scope.$on('$destroy', function() {
			if (angular.isObject(scrollable)) scrollable.off('scroll', handleScroll);
			cacheTimeline(1);
			angular.element($window).off('resize', scope.handleResize);
		});

		scope.$watch(function() {
			if (timelineFieldContainer === null) return;
			return timelineFieldContainer.attr('class');
		}, function(newValue, oldValue) {
			// Covers the case where the timeline was hidden and then reshown
			if (angular.isUndefined(newValue) || angular.isUndefined(oldValue)) return;
			if ((newValue.match(/ng-hide/) === null) && (oldValue.match(/ng-hide/) !== null)) {
				// The scroll can still be offset by loading content after this
				// This triggers handleScroll() so it can fix the scroll level after
				scope.data.initScroll = false;
				scrollable[0].scrollTop = scope.data.cachedScrollY;
			}
		});
	};
	
	return {
		restrict: 'E',
		templateUrl: 'template/timeline/timeline.html',
		scope: {
			data: '=?',
			tcTranslations: '=?'
		},
		controller: 'TimelineCtrl',
		link: timelineLink
	};
});
